import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export const CONTACT_EMAIL = "contact@dj-alchemist.com";

export const CopyEmail = ({ testId, className = "", iconSize = "w-3.5 h-3.5" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(CONTACT_EMAIL);
      setCopied(true);
      toast.success("Copied", { description: CONTACT_EMAIL });
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Couldn't copy — please copy manually");
    }
  };

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={handleCopy}
      title="Copy email"
      aria-label="Copy email to clipboard"
      className={`font-sub tracking-widest transition-colors duration-300 flex items-center gap-2 ${className}`}
    >
      {CONTACT_EMAIL.toUpperCase()}
      {copied ? (
        <Check className={`${iconSize} text-white/70`} />
      ) : (
        <Copy className={`${iconSize} text-white/30`} />
      )}
    </button>
  );
};
